import type { QueryClient } from "@tanstack/react-query";
import { fetchEnrollmentsForClass } from "@/lib/dashboard/teacher-class-enrollments";
import { QueryKeys } from "@/lib/types";

export async function prefetchTeacherClassEnrollments(
  queryClient: QueryClient,
  classIds: number[],
  accessToken: string,
) {
  if (classIds.length === 0) {
    return queryClient;
  }

  const sortedKey = [...classIds].sort((a, b) => a - b).join(",");
  const scope = "all";

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.TeacherClassEnrollments, sortedKey, scope],
    queryFn: async () => {
      const lists = await Promise.all(
        classIds.map((classId) =>
          fetchEnrollmentsForClass(accessToken, classId, scope),
        ),
      );
      return lists.flat();
    },
    staleTime: 60_000,
  });

  return queryClient;
}
